import React, { useState, useEffect, useMemo } from "react";
import FoodMenuService from "../../../Services/QRCodeServices/CustomerService/FoodMenuService";
import { useParams } from "react-router-dom";
import Loading from "../../Loading/Loading";
import { useNavigate } from "react-router-dom";

import TenantStylesLoader from "../../../Layouts/TenantStylesLoader";
import AllThemeFooter from "../Component/AllThemeFooter";
import Themes from '../../Theme/Theme';

const OrgPage = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { orgcode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await FoodMenuService.getFoodMenu(orgcode);
        //flatten menu items
        response.AllMenu = [
          { 'title': 'Food', 'id': 1, subcat: response.foodMenu },
          { 'title': 'Drinks', 'id': 2, subcat: response.drinkMenu },
          { 'title': 'Others', 'id': 3, subcat: response.others }
        ];
        //console.log(response);
        response.allItems = response.AllMenu // Get all categories (food, drinks, others)
          .flatMap((category) => 
            category.subcat.flatMap((sub) => sub.menuItem) // Access subcategories and their menuitems
          );
        console.log(response.allItems);
        

        setApiResponse(response);

        // Dynamic document title
        document.title = response?.organization?.name || 'Organization Page';
      } catch (error) {
        console.error('Error fetching organization data:', error);
        setError(error);
        // Optionally navigate on error
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [orgcode, navigate]);

  if (loading) return <Loading />;
  if (error) return <div>Error loading organization data</div>;

  return (
    <div>
      <TenantStylesLoader apiResponse={apiResponse} />

      {apiResponse?.theme && (
        <Themes.ThemeRenderer
          theme={apiResponse.theme}
          orgInfo={apiResponse}
        />
      )}

      <AllThemeFooter apiResponse={apiResponse} />
    </div>
  );
};

export default OrgPage;
